/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useContext } from 'react'

import Card from '@mui/material/Card'

import MDAvatar from 'components/MDAvatar'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { FormContext } from 'layouts/organisation-member/constants'
import DataTable from 'modules/Tables/DataTable'
import { ROUTE_PATHS } from 'routes'

function FeedbackTable() {
	const formContext = useContext(FormContext)
	const { localForm } = formContext

	if (localForm.feedbackTable) {
		return (
			<Card>
				<MDBox display={'flex'} flexDirection={'row'} gap={2} pt={3} pl={3}>
					<MDAvatar bgColor="primary" size="xs">
						5
					</MDAvatar>
					<MDTypography variant="h5" fontWeight="medium">
						Member Feedback Table
					</MDTypography>
				</MDBox>
				<DataTable
					table={localForm?.feedbackTable?.table}
					filters={localForm?.feedbackTable?.filters}
					parentPath={`${ROUTE_PATHS.FEEDBACK.BASE}`}
					entriesPerPage={{ defaultValue: 5, entries: [5, 10, 15] }}
				/>
			</Card>
		)
	} else {
		return <></>
	}
}

export default FeedbackTable
